<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
/*import UserLogin from './components/UserLogin.vue';

export default {
  components: {
    UserLogin
  }
};*/
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  font-size: 15px;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
